/**
 * クレジット上限値を制約する関数
 *
 * @param value 入力された値
 * @param maxLimit 最大値（アカウントのクレジット上限など）
 * @returns 制約された値（文字列）
 */
export const constrainCreditLimit = (value: string, maxLimit: number): string => {
  // 空文字列の場合はそのまま返す（上限なし）
  if (value === '') {
    return value;
  }

  // 数値に変換
  const numValue = parseInt(value, 10);

  // 0未満の場合は0に、最大値を超える場合は最大値に制限
  if (numValue < 0) {
    return '0';
  }
  if (numValue > maxLimit) {
    return maxLimit.toString();
  }
  return value;
};
